'use client';

/*
 * Documentation:
 * Pie Chart — https://app.subframe.com/6fc7f5fbb098/library?component=Pie+Chart_0654ccc7-054c-4f3a-8e9a-b7c81dd3963c
 */
import { c as _c } from "react/compiler-runtime";
import React from 'react';
import * as SubframeCore from '@subframe/core';
import * as SubframeUtils from '../utils';
interface PieChartRootProps extends React.ComponentProps<typeof SubframeCore.PieChart> {
  className?: string;
}
const PieChartRoot = React.forwardRef<React.ElementRef<typeof SubframeCore.PieChart>, PieChartRootProps>(function PieChartRoot(t0, ref) {
  const $ = _c(10);
  let className;
  let otherProps;
  if ($[0] !== t0) {
    ({
      className,
      ...otherProps
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = otherProps;
  } else {
    className = $[1];
    otherProps = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = SubframeUtils.twClassNames("h-52 w-52", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = ["#402a98", "#b4a7e7", "#2a1b63", "#8773d9", "#20154c", "#573bc9"];
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== otherProps || $[7] !== ref || $[8] !== t1) {
    t3 = <SubframeCore.PieChart className={t1} ref={ref} colors={t2} {...otherProps} />;
    $[6] = otherProps;
    $[7] = ref;
    $[8] = t1;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
});
const PieChart = PieChartRoot;